import { lazy } from 'react';

export const OnboardingPage = lazy(() =>
  import('@/pages/OnboardingPage/OnboardingPage').then(m => ({
    default: m.OnboardingPage,
  }))
);

export const OutfitsPage = lazy(() =>
  import('@/pages/MainPage/MainPage').then(m => ({ default: m.MainPage }))
);

export const ProfilePage = lazy(() =>
  import('@/pages/ProfilePage/ProfilePage').then(m => ({
    default: m.ProfilePage,
  }))
);

export const FittingPage = lazy(() =>
  import('@/pages/FittingPage/FittingPage').then(m => ({
    default: m.FittingPage,
  }))
);

export const FeedPage = lazy(() =>
  import('@/pages/FeedPage').then(m => ({
    default: m.FeedPage,
  }))
);

export const CatalogPage = lazy(() =>
  import('@/pages/CatalogPage').then(m => ({ default: m.CatalogPage }))
);

export const StylistsPage = lazy(() =>
  import('@/pages/StylistsPage').then(m => ({ default: m.StylistsPage }))
);

export const StylistPage = lazy(() =>
  import('@/pages/StylistPage').then(m => ({ default: m.StylistPage }))
);

export const TermsPage = lazy(() =>
  import('@/pages/TermsPage').then(m => ({ default: m.TermsPage }))
);

export const AuthPage = lazy(() =>
  import('@/pages/AuthPage/AuthPage').then(m => ({ default: m.AuthPage }))
);

export const SubscriptionPage = lazy(() =>
  import('@/pages/SubscriptionPage/SubscriptionPage').then(m => ({
    default: m.SubscriptionPage,
  }))
);

export const PaymentResultPage = lazy(() =>
  import('@/pages/PaymentResultPage/PaymentResultPage').then(m => ({
    default: m.PaymentResultPage,
  }))
);

export const ChatPage = lazy(() =>
  import('@/pages/ChatPage/ChatPage').then(m => ({ default: m.ChatPage }))
);
